import { YearPickerInput } from '@mantine/dates';
import classes from './YearPickerInput.module.css';

export const YearPickerInputConfig = YearPickerInput.extend({
  classNames: {
    input: classes.input,
  },
});
